import classnames from 'classnames';
import React from 'react';

import { Loading } from 'src/components/common/loading/Loading';
import { ShimmerLoading } from 'src/components/common/loading/ShimmerLoading';

export const ErrorsListLoading = () => (
  <>
    {[0, 1, 2].map((i) => (
      <div key={i} className="mb-4 flex">
        <ShimmerLoading className="h-12 w-full" />
      </div>
    ))}
  </>
);

export const ErrorsLoading = ({ className }: { className?: string }) => {
  return (
    <div className={classnames('chromatic-ignore', className)}>
      <div className="flex min-h-80 items-center justify-center">
        <Loading />
      </div>
      <ErrorsListLoading />
    </div>
  );
};
